import PropTypes from 'prop-types'

import { Flex } from 'shared/ui'
import Label from '../Label'
import Row from '../IndentedRow'
import Input from './Input'

const SubjectRow = ({
  className,
  draft,
  onChange,
  onEnter,
  startInEditMode,
}) => {
  return (
    <Row className={className} flex="1 0 100%">
      <Label>Subject:</Label>
      <Flex ml={1} flex={1}>
        <Input
          draft={draft}
          onChange={onChange}
          onEnter={onEnter}
          startFocused={startInEditMode}
        />
      </Flex>
    </Row>
  )
}

SubjectRow.propTypes = {
  draft: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onEnter: PropTypes.func,
}

SubjectRow.defaultProps = {
  onEnter: undefined,
}

export default SubjectRow
